import { scrollToId } from "./Reveal";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-[#0B0B12] border-t border-[#A89DE3]/15 px-4 sm:px-8 lg:px-12 pt-10 pb-28 md:pb-10">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
        <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-white p-1.5">
          <img src="/images/logo.png" alt="HERcules Health logo" data-testid="footer-logo" className="h-full w-auto" />
        </span>
        <p className="text-xs uppercase tracking-[0.2em] text-[#A89DE3]">Back To You — Free 14-Day Metabolic Reset</p>
        <button
          data-testid="footer-join-button"
          onClick={() => scrollToId("register")}
          className="rounded-full border border-[#A89DE3]/40 text-[#FFFFFF] px-5 py-2 text-sm font-semibold hover:bg-[#7C89FF] hover:border-[#7C89FF] transition-colors duration-300"
        >
          JOIN THE RESET - FREE
        </button>
      </div>
    </footer>
  );
}
